import {
  ApiBlueprint,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/frontend-plugin-api';
import { AccessApiClient, accessApiRef } from '../api';

export const accessApiExtension = ApiBlueprint.make({
  name: 'access',
  params: defineParams =>
    defineParams({
      api: accessApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new AccessApiClient(discoveryApi, fetchApi),
    }),
});
